// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.json-form-renderer-container {
  border: 1px solid #ced4da;
  padding: 10px;
  height: 267px;
  overflow-x: hidden;
  overflow-y: scroll;
  background: white;
}`, "",{"version":3,"sources":["webpack://./../gui/src/public/css/JSONFormRenderer.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAAJ","sourcesContent":["\n  .json-form-renderer-container{\n    border: 1px solid #ced4da;\n    padding: 10px;\n    height: 267px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    background: white;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
